var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReadMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.13408 0C12.6264 0 16.2682 3.58172 16.2682 8C16.2682 12.4183 12.6264 16 8.13408 16C3.64175 16 0 12.4183 0 8C0 3.58172 3.64175 0 8.13408 0ZM8.13518 2C4.76593 2 2.03462 4.68629 2.03462 8C2.03462 11.3137 4.76593 14 8.13518 14C11.5044 14 14.2357 11.3137 14.2357 8C14.2357 4.68629 11.5044 2 8.13518 2ZM10.5939 5.03899L6.79832 8.77196L5.29433 7.29276L5.19855 7.20957C4.79968 6.90455 4.22294 6.93228 3.85642 7.29276C3.45935 7.68328 3.45935 8.31645 3.85642 8.70697L6.07936 10.8933L6.17515 10.9765C6.57401 11.2815 7.15075 11.2538 7.51728 10.8933L12.0318 6.4532L12.1163 6.35899C12.4265 5.9667 12.3983 5.39947 12.0318 5.03899C11.6347 4.64846 10.9909 4.64846 10.5939 5.03899Z",
    fill: "#62BB58"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReadMessage);
export default __webpack_public_path__ + "static/media/read-message.69e927514576c0c7444bc484f8561fac.svg";
export { ForwardRef as ReactComponent };